import { memo } from "react"
import { Box, Typography, IconButton, Tooltip } from "@mui/material"
import { useGridApiContext, useGridSelector, gridRowCountSelector } from "@mui/x-data-grid-premium"
import { Compress, Expand } from "@mui/icons-material"
import { resizeColumnsByHeaderNode, collapseColumns } from "../helpers"

const TableFooter = memo(() => {
  const apiRef = useGridApiContext()
  const totalRowCount = useGridSelector(apiRef, gridRowCountSelector)

  return (
    <Box className="custom-footer">
      <Box className="custom-footer-left">
        <Tooltip title="Collapse columns">
          <IconButton
            size="small"
            onClick={() => collapseColumns(apiRef)}
          >
            <Compress
              fontSize="small"
              sx={{ transform: "rotate(90deg)" }}
            />
          </IconButton>
        </Tooltip>
        <Tooltip title="Expand columns">
          <IconButton
            size="small"
            onClick={() => resizeColumnsByHeaderNode(apiRef)}
          >
            <Expand
              fontSize="small"
              sx={{ transform: "rotate(90deg)" }}
            />
          </IconButton>
        </Tooltip>
      </Box>
      <Box className="custom-footer-center" />
      <Box className="custom-footer-right">
        <Typography variant="caption" className="custom-footer-label">
          {totalRowCount} {totalRowCount === 1 ? "row" : "rows"}
        </Typography>
      </Box>
    </Box>
  )
})

TableFooter.displayName = "TableFooter"

export default TableFooter
